import { z } from 'zod';
import { PagoSchema } from './pago';
const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const TotalesPagoSchema = z.object({
    ingresos: z.coerce.number(),
    egresos: z.coerce.number(),
    neto: z.coerce.number(),
});
export const PagosGlobalesSchema = z.object({
    items: z.array(PagoSchema),
    totales: TotalesPagoSchema.optional(),
    paginacion: PaginacionSchema,
});
export const METODOS_PAGO_FILTRO = [
    'EFECTIVO',
    'TARJETA',
    'TARJETA_CREDITO',
    'TARJETA_DEBITO',
    'TRANSFERENCIA',
    'MERCADOPAGO',
];
export const ESTADOS_PAGO = ['REGISTRADO', 'REVERSADO', 'ANULADO'];
